import {
  AppBar,
  Fade,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Nunito",
  },
  appbarHome: { background: "none" },
  appBarOther: {
    background: "#dedede",
  },
  iconHome: {
    color: "#fff",
    fontSize: "2rem",
  },
  iconOther: {
    color: "#000000",
    fontSize: "2rem",
  },
  appbarWrapper: {
    width: "95%",
    margin: "0 auto",
  },
  appbarTitle: {
    flexGrow: "1",
    width: "130px",
    height: "130px",
    objectFit: "contain",
    objectPosition: "left",
    margin: theme.spacing(1),
  },
  pageTitle: {
    color: "white",
    marginRight: theme.spacing(1),
  },
}));

const Header = (props) => {
  const { currPage, setCurrPage } = props;

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [header, setHeader] = useState("header");

  const listenScrollEvent = (event) => {
    if (window.scrollY < 477) {
      return setHeader("header");
    } else if (window.scrollY > 70) {
      return setHeader("header2");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    setAnchorEl(null);
    if (event.currentTarget.href !== undefined) {
      setCurrPage(event.target.text);
    }
  };

  return (
    <>
      <div className={classes.root}>
        <AppBar
          className={
            currPage === "Home" ? classes.appbarHome : classes.appBarOther
          }
          elevation={0}
          position={currPage === "Home" ? "fixed" : "relative"}
          style={
            header === "header2"
              ? {
                  background: "#dedede",
                  transition: "all .2s ease-in",
                }
              : { transition: "all .2s ease-in" }
          }
        >
          <Toolbar className={classes.appbarWrapper}>
            <img
              className={classes.appbarTitle}
              src="/assets/C_R_LOGO.png"
              alt="C&R logo"
            ></img>
            <h1
              className={classes.pageTitle}
              style={
                currPage !== "Home" || header === "header2"
                  ? {
                      color: "black",
                    }
                  : {}
              }
            >
              {currPage}
            </h1>
            <IconButton onClick={handleClick}>
              <MenuIcon
                className={
                  currPage === "Home" ? classes.iconHome : classes.iconOther
                }
                style={header === "header2" ? { color: "#000" } : {}}
              />
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              TransitionComponent={Fade}
            >
              <MenuItem onClick={handleClose} component={Link} to={"/"}>
                Home
              </MenuItem>
              <MenuItem onClick={handleClose} component={Link} to={"/services"}>
                Services
              </MenuItem>
              <MenuItem onClick={handleClose} component={Link} to={"/our-work"}>
                Our Work
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={"/testimonials"}
              >
                Testimonials
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={"/contact-us"}
              >
                Contact Us
              </MenuItem>
              <MenuItem onClick={() => handleClose(false)}>Pay Online</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
};

export default Header;
